module.exports = __webpack_public_path__ + "img/bed.609b0671.png";